{
  "Calls": "Calls",
  "calls": "Calls",
  "search-calls": "Search Calls",
  "filter-calls": "Filter Calls",
  "all": "All",
  "answered": "Answered",
  "missed": "Missed",
  "abandoned": "Abandoned",
  "forwarded": "Forwarded",
  "apply": "Apply",
  "voicemail": "Voicemail",
  "comingSoon": "Voicemail coming soon",
  "voicemailDeletedSuccess": "Voicemail deleted successfully",
  "voicemailDeletedError": "Failed to delete voicemail",
  "markasread": "Mark as read",
  "markasunread": "Mark as unread",
  "download": "Download",
  "delete": "Delete"
}
